import { BucketHttpGateway } from "../gateway/BucketHttpGateway";

const ESOCIAL_EVENTS_FILES_BUCKET = `${publicSettings.aws.buckets.eSocial}`;

export class DownloadESocialRequestFileUsecase {
    constructor() {
        this.BucketHttpGateway = new BucketHttpGateway();
    }

    async execute({ fileUrlS3 = "" } = {}) {
        const payload = this.sanitizeInput({ fileUrlS3 });
        if (!payload.key || !payload.bucket) return null;
        const response = await this.BucketHttpGateway.getSignedUrlByKey(
            payload.key,
            payload.bucket
        );
        return response?.signedUrl;
    }

    sanitizeInput({ fileUrlS3 = "" } = {}) {
        const trimmed = String(fileUrlS3).trim();
        const afterComMarker = ".com/";
        const comIdx = trimmed.indexOf(afterComMarker);
        if (comIdx === -1) {
            return { key: "", bucket: ESOCIAL_EVENTS_FILES_BUCKET };
        }
        let key = trimmed.slice(comIdx + afterComMarker.length);
        const queryIdx = key.indexOf("?");
        if (queryIdx !== -1) {
            key = key.slice(0, queryIdx);
        }
        const hashIdx = key.indexOf("#");
        if (hashIdx !== -1) {
            key = key.slice(0, hashIdx);
        }
        key = key.replace(/^\/+/, "").trim();
        return {
            key,
            bucket: ESOCIAL_EVENTS_FILES_BUCKET
        };
    }
}
